export default "__VITE_ASSET__D9x93Npv__"